import React, { FC } from "react";
import { BsInfoCircle } from "react-icons/bs";

import Panel from "./Panel";

const DescriptionPanel: FC = () => {
  return (
    <Panel
      initiallyDeployed
      title={
        <>
          <BsInfoCircle className="text-muted" /> Description
        </>
      }
    >
      <p>இந்த வரைபடம் தமிழ்.விக்கி பதிவுகளை இணைத்து ஒரு வலைப்பின்னலாக காட்டுகிறது. ஒவ்வொரு புள்ளியும் ஒரு பதிவு, கோடுகள் அவற்றுக்கிடையேயான சுட்டி இணைப்புகள் ஆகும். வகைகள் மற்றும் பகுதி வாரியாக விக்கியை வாசிக்கலாம்</p>
      
      <p>இந்த மொத்த அறிவுப்பின்னலில் ஒவ்வொரு பதிவுக்கும் ஒரு முக்கியத்துவம் உள்ளது. அந்த முக்கியத்துவம் {" "}<a target="_blank" rel="noreferrer" href="https://en.wikipedia.org/wiki/Centrality#PageRank_centrality">கணிதரீதியாக</a> புள்ளியின் அளவின் மூலம் குறிப்பிடப்படுகிறது. பெரிய புள்ளிகள் இந்த அறிவுப்பின்னலை இணைக்கின்றன. இணைப்புச் சுட்டிகள் சேரச்சேர இந்த அறிவுப்பின்னல் அடர்த்தி பெறும்.</p>

      <p>Graph theory, Network analysis, Data Science, Visualization போன்ற நவீன அணுகுமுறைகள் மூலம் அறிவுத்துறைகளை விளக்கும் முயற்சிகள் உலகெங்கும் நடைபெறுகின்றன. தமிழ் அறிவியக்கச் சூழலின் வரைபடத்தை தொகுக்கும் முயற்சியாக இதை முன்வைக்கிறோம்.</p>

      <p>இந்த இணையதளம் {" "}<a target="_blank" rel="noreferrer" href="https://www.ouestware.com/en/">OuestWare நிறுவனத்தினர் உருவாக்கிய செயலிகளை கொண்டு </a>{" "}<a target="_blank" rel="noreferrer" href="https://reactjs.org/">ரியாக்ட்</a>{" "}மற்றும் {" "}<a target="_blank" rel="noreferrer" href="https://www.sigmajs.org">சிக்மா ஜாவாஸ்க்ரிப்ட்</a>மூலம் உருவாக்கப்பட்டுள்ளன. இவற்றின் நிரல்மூலம்{" "}<a target="_blank" rel="noreferrer" href="https://github.com/jacomyal/sigma.js/tree/main/demo"> கிட்ஹப் இணையதளத்தில் </a>கிடைக்கிறது. இந்த டெமோ செயலியின் உரிமங்கள் இந்த நபர்கள் மற்றும் நிறுவனங்களிடம் உள்ளன. தமிழ் விக்கி குழுவினர் இவற்றை எடுத்துக்காட்டாக மட்டுமே பயன்படுத்துகிறோம். இச்செயலிகளை உருவாக்கியவர்களுக்கு எங்கள் நன்றி.</p>
      
    </Panel>
  );
};

export default DescriptionPanel;
